// @flow
import React, {PureComponent} from 'react'
import {NotificationContainer, NotificationManager} from 'modules/Common/components/Notification'
import I18n from 'I18n'
import styles from './Login.module.scss'

import LogoIcon from 'modules/Authenticate/components/svgIcons/logo.svg'
import LoginForm from 'modules/Authenticate/components/LoginForm'

import type {DispatchProps, OwnProps, StateProps} from '../../containers/LoginContainer'

const I18nLocal = I18n.landing

export type Props = StateProps & DispatchProps & OwnProps;

type State = {
  name: string,
  password: string
};

export class Login extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      name: '',
      password: ''
    }
  }

  _handleEscKey = (event: any) => {
    if (event.keyCode === 13) {
      this.login()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this._handleEscKey, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleEscKey)
  }

  login = () => {
    if (this.state.password.length === 0 || this.state.name.length === 0) {
      NotificationManager.error(I18nLocal.errorMustNotEmpty)
    }
    if (this.state.name.length > 0 && this.state.password.length > 0 && !this.props.isLogging) {
      this.props.login(this.state.name, this.state.password).then(() => {
        if (this.props.error) {
          NotificationManager.error(I18nLocal.errorMessage)
        }
      })
    }
  }

  handleChangeName = (value: string) => {
    this.setState({
      name: value
    })
  }

  handleChangePassword = (value: string) => {
    this.setState({
      password: value
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.logo}>
          <LogoIcon width={200} height={70} />
        </div>

        <LoginForm
          handleChangePassword={this.handleChangePassword}
          handleChangeName={this.handleChangeName}
          name={this.state.name}
          password={this.state.password}
          login={this.login}
          isLogging={this.props.isLogging}
          isAdminLogin={true}
        />

        <div className={styles.footer}>
          <p>
            <span>{I18nLocal.poweredBy} </span>
            <a
              className={styles['name-project']}
              href={'https://www.leap.expert/'}
              target='_blank'
              rel='noopener noreferrer'
            >
              {'LeapXpert'}
            </a>
          </p>
        </div>
        <NotificationContainer />
      </div>
    )
  }
}

export default Login
